export const uuid = () => {
  try {
    return crypto.randomUUID();  // Only available in HTTPS contexts
  } catch (e) {
    let randomDigits = parseInt(Math.random() * Date.now()).toString();
    let parts = [8, 4, 4, 4, 12]
    parts = parts.map(e => randomDigits.slice(0, Math.min(e, randomDigits.length)))
    return parts.join('-')
  }
}

